import { EventEmitter } from "events";

const eventBus = new EventEmitter();
export default eventBus;
